<template>
  <!-- 批量添加设备组件 -->
  <div class="page forbit-cancel-tree">
    <Modal
      v-model="dialogVisible"
      class="page-modal"
      width="60%"
      :mask-closable="false"
      :footer-hide="true"
      :title="$t('deviceSip.batch')"
      class-name="vertical-center-modal"
    >
      <Spin v-if="spinShow" size="large" fix></Spin>
      <div ref="addBatchDevice" class="modalHeight adddevice-box">
        <!-- 批量导入设备的区域信息 -->
        <Row class="margin-bottom-30">
          <i-col span="12" class="area-box flex-box">
            <span>{{ $t("deviceSip.areaChosen") }}</span>
            <!-- 区域层级描述list -->
            <Select v-model="currentAreaType" size="large" style="width: 200px">
              <Option
                v-for="item in areaTypeNameList"
                :key="item.areaTypeLevel"
                :value="item.areaTypeLevel"
              >
                {{ item.areaTypeName }}
              </Option>
            </Select>
          </i-col>
          <i-col span="12" class="area-box flex-box">
            <span>{{ $t("deviceSip.areaNum") }}</span>
            <!-- 设备数 -->
            <Select
              v-model="currentDeviceNum"
              size="large"
              style="width: 200px"
            >
              <Option v-for="item in 8" :key="item" :value="item">
                {{ item }}
              </Option>
            </Select>
            <Poptip
              trigger="hover"
              :title="$t('deviceSip.note')"
              placement="left"
            >
              <template #content>
                <h4 class="bacth-box-tip">
                  {{ $t("deviceSip.bacthTip") }}
                </h4>
              </template>
              <Icon type="md-help-circle" size="24" color="#FFB22B" />
            </Poptip>
          </i-col>
        </Row>
        <!-- 基本信息配置 -->
        <Row class="margin-bottom-20">
          <i-col span="3" class="label-box text-center">
            <h4>*{{ $t("deviceSip.baseConfig") }}</h4>
          </i-col>
          <i-col span="20">
            <Form
              ref="addForm"
              :label-width="200"
              :model="addForm"
              label-colon
              :rules="ruleValidateBaseDevice_batch"
            >
              <!-- 设备名称 -->
              <FormItem prop="name" :label="$t('deviceSip.deviceName')">
                <Input
                  :value="$t('deviceSip.nameTip')"
                  size="large"
                  clearable
                  disabled
                />
              </FormItem>
              <!-- 设备支持功能 -->
              <FormItem prop="funList" :label="$t('deviceSip.function')">
                <RadioGroup
                  v-model="addForm.productType"
                  @on-change="setFunList"
                >
                  <Radio
                    v-for="item in allDevList"
                    :key="item.value"
                    :label="item.value"
                  >
                    <span>{{ item.label }}</span>
                  </Radio>
                </RadioGroup>
                <!-- 选择其他的设备类型，需要带出设备类型的选项 -->
                <Row
                  v-if="Number(addForm.productType) == 0"
                  gutter="20"
                  class="margin-box"
                >
                  <i-col span="24">
                    <Select
                      v-model="addForm.deviceType"
                      size="large"
                      :placeholder="$t('newDeviceType.deviceTypeTip')"
                    >
                      <Option
                        v-for="item in deviceTypeList"
                        :key="item.value"
                        :value="item.value"
                      >
                        {{ item.label }}
                      </Option>
                    </Select>
                  </i-col>
                </Row>
                <Row gutter="20">
                  <i-col span="16">
                    <CheckboxGroup v-model="addForm.funList">
                      <Checkbox
                        v-for="item in allFunList"
                        :key="item.value"
                        :label="item.value"
                        :disabled="
                          Number(addForm.productType) == 0 ? false : true
                        "
                      >
                        <span>{{ item.label }}</span>
                      </Checkbox>
                    </CheckboxGroup>
                  </i-col>
                  <i-col span="2">
                    <Poptip
                      trigger="hover"
                      :title="$t('deviceSip.note')"
                      placement="left"
                    >
                      <template #content>
                        <h4>{{ $t("updateNewSip.funTitle") }}</h4>
                        <h4>
                          "{{ $t("updateNewSip.callin") }}":&nbsp;
                          {{ $t("updateNewSip.callInTip") }}
                        </h4>
                        <h4>
                          "{{ $t("updateNewSip.callout") }}":&nbsp;
                          {{ $t("updateNewSip.callOutTip") }}
                        </h4>
                        <h4>
                          "{{ $t("deviceSip.monitor") }}":&nbsp;
                          {{ $t("updateNewSip.monitorTip") }}
                        </h4>
                        <h4>
                          "{{ $t("updateNewSip.doorAuth") }}":&nbsp;
                          {{ $t("updateNewSip.doorTip") }}
                        </h4>
                        <h4>
                          "{{ $t("deviceSip.lift") }}":&nbsp;
                          {{ $t("updateNewSip.liftTip") }}
                        </h4>
                      </template>
                      <Icon type="md-help-circle" size="24" color="#FFB22B" />
                    </Poptip>
                  </i-col>
                </Row>
              </FormItem>
            </Form>
          </i-col>
        </Row>
        <!-- 网络配置 -->
        <Row class="margin-bottom-20">
          <i-col span="3" class="label-box text-center">
            <h4>*{{ $t("deviceSip.net") }}</h4>
          </i-col>
          <i-col span="20">
            <Form
              ref="netForm"
              :label-width="200"
              :model="netForm"
              label-colon
              :rules="ruleValidateNet1"
            >
              <!-- 网络类型，只有static -->
              <FormItem prop="mode" :label="$t('deviceSip.netType')">
                <Row>
                  <i-col span="8">
                    <RadioGroup v-model="netForm.mode">
                      <Radio :label="1">
                        <span>Static</span>
                      </Radio>
                    </RadioGroup>
                  </i-col>
                  <i-col span="1" class="flex-box1">
                    <Poptip trigger="hover" :title="$t('deviceSip.note')">
                      <template #content>
                        <h4>{{ $t("deviceSip.netTip1") }}</h4>
                      </template>
                      <Icon type="md-help-circle" size="24" color="#FFB22B" />
                    </Poptip>
                  </i-col>
                </Row>
              </FormItem>
              <!-- 请重新输入子网掩码 -->
              <FormItem
                v-if="netForm.mode === 1"
                prop="mask"
                :label="$t('deviceSip.mask')"
              >
                <Input
                  v-model="netForm.mask"
                  size="large"
                  :placeholder="$t('updateNewSip.maskTip')"
                  clearable
                  @on-blur="validateIpAndMask()"
                />
              </FormItem>
              <!-- 请重新输入网关 -->
              <FormItem
                v-if="netForm.mode === 1"
                prop="gateway"
                :label="$t('deviceSip.gateway')"
              >
                <Input
                  v-model="netForm.gateway"
                  size="large"
                  :placeholder="$t('updateNewSip.gatewayTip')"
                  clearable
                />
              </FormItem>
              <!-- 请重新输入IP地址 -->
              <FormItem
                v-if="netForm.mode === 1"
                prop="ip"
                :label="$t('deviceSip.ip')"
              >
                <Row>
                  <i-col span="24">
                    <Input
                      v-model="netForm.ip"
                      size="large"
                      :placeholder="$t('updateNewSip.ip1')"
                      clearable
                      @on-blur="validateIpAndMask()"
                    />
                  </i-col>
                </Row>
              </FormItem>
              <!-- 请重新输入DNS1 -->
              <FormItem
                v-if="netForm.mode === 1"
                prop="dns1"
                :label="$t('deviceSip.dns1')"
              >
                <Input
                  v-model="netForm.dns1"
                  size="large"
                  :placeholder="$t('updateNewSip.dns1')"
                  clearable
                />
              </FormItem>
              <!-- 请重新输入DNS2 -->
              <FormItem
                v-if="netForm.mode === 1"
                prop="dns2"
                :label="$t('deviceSip.dns2')"
              >
                <Input
                  v-model="netForm.dns2"
                  size="large"
                  :placeholder="$t('updateNewSip.dns2')"
                  clearable
                />
              </FormItem>
            </Form>
          </i-col>
        </Row>
        <!-- sip1信息配置 -->
        <Row class="margin-bottom-20">
          <i-col span="3" class="label-box text-center">
            <h4>*{{ $t("deviceSip.sip1") }}</h4>
          </i-col>
          <i-col span="20">
            <Form
              ref="sipForm1"
              :label-width="200"
              :model="sipForm1"
              label-colon
              :rules="sipForm1.mode === 1 ? {} : ruleValidateSip1_batch"
            >
              <!-- SIP模式 -->
              <FormItem prop="mode" :label="$t('deviceSip.mode')">
                <RadioGroup v-model="sipForm1.mode">
                  <Radio :label="1">
                    <span>{{ $t("deviceSip.mode1") }}</span>
                  </Radio>
                  <Radio :label="2">
                    <span>{{ $t("deviceSip.mode2") }}</span>
                  </Radio>
                </RadioGroup>
              </FormItem>
              <!-- 请重新输入用户名 -->
              <FormItem prop="account" :label="$t('deviceSip.user')">
                <Row>
                  <i-col span="23">
                    <Input
                      :value="$t('updateNewSip.userSipAccount')"
                      size="large"
                      :placeholder="$t('updateNewSip.userSipAccount')"
                      clearable
                      disabled
                    />
                  </i-col>
                  <i-col span="1" class="flex-box1">
                    <Poptip
                      trigger="hover"
                      :title="$t('deviceSip.note')"
                      placement="left"
                    >
                      <template #content>
                        <h4>{{ $t("deviceSip.sipTip") }}</h4>
                      </template>
                      <Icon type="md-help-circle" size="24" color="#FFB22B" />
                    </Poptip>
                  </i-col>
                </Row>
              </FormItem>
              <!-- 密码 -->
              <FormItem
                v-if="sipForm1.mode === 2"
                prop="password"
                :label="$t('deviceSip.password')"
              >
                <Input
                  v-model="sipForm1.password"
                  size="large"
                  :placeholder="$t('deviceSip.password')"
                  clearable
                  :maxlength="32"
                />
              </FormItem>
              <!--  请重新输入serverIP -->
              <FormItem
                v-if="sipForm1.mode === 2"
                prop="serviceIp"
                :label="$t('deviceSip.serverIp')"
              >
                <Row>
                  <i-col span="23">
                    <Input
                      v-model="sipForm1.serviceIp"
                      size="large"
                      :placeholder="$t('updateNewSip.serverIp')"
                      clearable
                    />
                  </i-col>
                  <i-col span="1" class="flex-box1">
                    <Poptip
                      trigger="hover"
                      :title="$t('deviceSip.note')"
                      placement="left"
                    >
                      <template #content>
                        <h4>{{ $t("deviceSip.ipTip") }}</h4>
                      </template>
                      <Icon type="md-help-circle" size="24" color="#FFB22B" />
                    </Poptip>
                  </i-col>
                </Row>
              </FormItem>
              <!-- 请重新选择协议类型 -->
              <FormItem
                v-if="sipForm1.mode === 2"
                prop="protocolType"
                :label="$t('deviceSip.protocolType')"
              >
                <RadioGroup v-model="sipForm1.protocolType">
                  <Radio :label="1">
                    <span>UDP</span>
                  </Radio>
                  <Radio :label="2">
                    <span>TCP</span>
                  </Radio>
                  <Radio :label="3">
                    <span>TLS</span>
                  </Radio>
                </RadioGroup>
              </FormItem>
            </Form>
          </i-col>
        </Row>
        <!-- sip2信息配置--更多展示 -->
        <Row v-if="!isExpandSip2" class="margin-bottom-20">
          <i-col span="3" class="text-center">
            <h4>{{ $t("deviceSip.sip2") }}</h4>
          </i-col>
          <i-col span="17" offset="1">
            <hr class="more-hr" />
          </i-col>
          <i-col span="2" offset="1" class="more-box">
            <span class="area-box more-text" @click="expandMore">{{
              $t("deviceSip.more")
            }}</span>
            <span class="more-img" @click="expandMore"></span>
          </i-col>
        </Row>
        <!--sip2信息配置  -->
        <Row v-else class="margin-bottom-20 relative-box">
          <i-col span="2" offset="1" class="more-box position-box">
            <span class="area-box more-text" @click="expandMore">{{
              $t("deviceSip.close")
            }}</span>
            <span class="more-img tranform-box" @click="expandMore"></span>
          </i-col>
          <i-col span="3" class="text-center">
            <h4>{{ $t("deviceSip.sip2") }}</h4>
          </i-col>
          <i-col span="20">
            <Form
              ref="sipForm2"
              :label-width="200"
              :model="sipForm2"
              label-colon
              :rules="sipForm2.mode === 1 ? emptyRule : ruleValidateSip2_batch"
            >
              <!-- SIP模式 -->
              <FormItem prop="mode" :label="$t('deviceSip.mode')">
                <RadioGroup v-model="sipForm2.mode">
                  <Radio :label="1">
                    <span>{{ $t("deviceSip.mode1") }}</span>
                  </Radio>
                  <Radio :label="2">
                    <span>{{ $t("deviceSip.mode2") }}</span>
                  </Radio>
                </RadioGroup>
              </FormItem>
              <!-- 请重新输入用户名 -->
              <FormItem prop="account" :label="$t('deviceSip.user')">
                <Row>
                  <i-col span="23">
                    <Input
                      :value="$t('updateNewSip.userSipAccount')"
                      size="large"
                      :placeholder="$t('updateNewSip.userSipAccount')"
                      clearable
                      disabled
                    />
                  </i-col>
                  <i-col span="1" class="flex-box1">
                    <Poptip
                      trigger="hover"
                      :title="$t('deviceSip.note')"
                      placement="left"
                    >
                      <template #content>
                        <h4>{{ $t("deviceSip.sipTip") }}</h4>
                      </template>
                      <Icon type="md-help-circle" size="24" color="#FFB22B" />
                    </Poptip>
                  </i-col>
                </Row>
              </FormItem>
              <!-- 密码 -->
              <FormItem
                v-if="sipForm2.mode === 2"
                prop="password"
                :label="$t('deviceSip.password')"
              >
                <Input
                  v-model="sipForm2.password"
                  size="large"
                  :placeholder="$t('deviceSip.password')"
                  clearable
                  :maxlength="32"
                />
              </FormItem>
              <!--  请重新输入serverIP -->
              <FormItem
                v-if="sipForm2.mode === 2"
                prop="serviceIp"
                :label="$t('deviceSip.serverIp')"
              >
                <Row>
                  <i-col span="23">
                    <Input
                      v-model="sipForm2.serviceIp"
                      size="large"
                      :placeholder="$t('updateNewSip.serverIp')"
                      clearable
                    />
                  </i-col>
                  <i-col span="1" class="flex-box1">
                    <Poptip
                      trigger="hover"
                      :title="$t('deviceSip.note')"
                      placement="left"
                    >
                      <template #content>
                        <h4>{{ $t("deviceSip.ipTip") }}</h4>
                      </template>
                      <Icon type="md-help-circle" size="24" color="#FFB22B" />
                    </Poptip>
                  </i-col>
                </Row>
              </FormItem>
              <!-- 请重新选择协议类型 -->
              <FormItem
                v-if="sipForm2.mode === 2"
                prop="protocolType"
                :label="$t('deviceSip.protocolType')"
              >
                <RadioGroup v-model="sipForm2.protocolType">
                  <Radio :label="1">
                    <span>UDP</span>
                  </Radio>
                  <Radio :label="2">
                    <span>TCP</span>
                  </Radio>
                  <Radio :label="3">
                    <span>TLS</span>
                  </Radio>
                </RadioGroup>
              </FormItem>
            </Form>
          </i-col>
        </Row>
      </div>
      <!-- 底部按钮 -->
      <div class="detailBackBtn">
        <Button size="large" @click="closeModal">{{
          $t("common.cancel")
        }}</Button>
        <Button type="primary" size="large" @click="handleSubmit">{{
          $t("common.ensure")
        }}</Button>
      </div>
    </Modal>
    <div class="content_win">
      <!-- 提交确认弹窗 -->
      <modal ref="resultModal" :type="modalType" @afterComfirm="closeModal">
        <div slot="info">
          <p>{{ $t("updateNewSip.batchIpTip") }}:</p>
          <p>{{ startIp }}-{{ endIp }}</p>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getAllParentNode } from "@/utils/tree";
import { checkIPAndSubnet, addDeviceIP } from "@/utils/validateIP.js";

export default {
  name: "addBatchDeviceModal",
  props: {
    isBatchDevice: {
      type: Boolean,
      default: false,
    },
    deviceType: {
      // 设备modal的操作类型 ：0新增，1编辑
      type: Number,
      default: 0,
    },
    currentNode: {
      // 左侧树选中的节点信息
      type: Object,
      default() {
        return {};
      },
    },
    areaTypeNameList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      spinShow: false,
      startIp: "", // 批量导入的设备ip开始
      endIp: "", // 批量导入的设备ip结束
      currentAreaType: 1, // 当前选中的区域层级
      currentDeviceNum: 1, // 当前选中的区域设备数量
      isExpandSip2: false, // 展开sip2配置
      dialogVisible: false,
      addForm: {
        name: "",
        funList: [0, 1, 3],
        deviceType: 1, //
        productType: "SI701",
      }, // 设备表单
      productType: 1,
      netForm: {
        mode: 1,
        ip: "",
        gateway: "",
        mask: "",
        dns1: "",
        dns2: "",
      }, // 网络配置表单
      sipForm1: {
        account: "",
        accountLast: "",
        mode: 1,
        password: "",
        protocolType: 1,
        serviceIp: "",
      }, // sip1配置表单
      sipForm2: {
        account: "",
        accountLast: "",
        mode: 1,
        password: "",
        protocolType: 1,
        serviceIp: "",
      }, // sip2配置表单
      modalType: false,
      emptyRule: {},
      batchDeviceNum: 0, // 单次批量添加设备的数量
    };
  },
  computed: {
    ...mapState("projectConfig", [
      "deviceTypeList",
      "areaData",
      "areaDeviceData",
      "allFunList",
      "allDevList",
      "ruleValidateBaseDevice_batch",
      "ruleValidateNet1",
      "ruleValidateSip1_batch",
      "ruleValidateSip2_batch",
      "allDeviceNum",
    ]),
  },
  watch: {
    dialogVisible: {
      handler() {
        if (this.dialogVisible === false) {
          this.$refs.addBatchDevice.scrollTop = 0; // 始终在顶层
          this.addForm.deviceType = 1;
          this.addForm.productType = "SI701";
          this.$refs.addForm.resetFields();
          this.currentAreaType = 1;
          this.currentDeviceNum = 1;
          this.$refs["netForm"].resetFields();
          this.$refs["sipForm1"].resetFields();
          this.sipForm1.accountLast = "";
          this.sipForm2.accountLast = "";

          if (this.$refs.sipForm2) {
            this.$refs["sipForm2"].resetFields();
          }

          this.isExpandSip2 = false;
          // 弹窗关闭 清空数据
        }
      },
    },
  },
  methods: {
    // 校验ip的正确性，ip&mask  相对段二进制&
    validateIpAndMask() {
      const { mask, ip } = this.netForm;
      if (ip.length > 0 && mask.length === 0) {
        if (!this.notAllZoneIpReg.test(mask)) {
          this.$Message.error(this.$t("updateNewSip.correctMaskTip"));
          return;
        }
      }

      if (ip.length > 0 && mask.length > 0) {
        if (!this.notAllZoneIpReg.test(ip)) {
          this.$Message.error(this.$t("updateNewSip.correctIpTip"));
          return;
        }
      }

      // 检查 IP 地址与子网掩码按位与的结果是否全为 0 或全为 1
      let isCorrectResult = checkIPAndSubnet(ip, mask);

      if (isCorrectResult) {
        this.$Message.error(this.$t("updateNewSip.ipAndMaskTip3"));
        this.netForm.ip = "";
        return;
      }
    },

    // 展示更多
    expandMore() {
      this.isExpandSip2 = !this.isExpandSip2;
    },
    closeModal() {
      this.dialogVisible = false;
    },
    // 提交方法
    handleSubmit() {
      let that = this;
      let addForm = new Promise((resolve, reject) => {
        this.$refs["addForm"].validate((valid) => {
          if (valid) {
            resolve();
          } else {
            // 返回验证失败的表单名称
            reject("addForm");
          }
        });
      });
      let netForm = new Promise((resolve, reject) => {
        this.$refs["netForm"].validate((valid) => {
          if (valid) {
            resolve();
          } else {
            // 返回验证失败的表单名称
            reject("netForm");
          }
        });
      });
      let sipForm1 = new Promise((resolve, reject) => {
        this.$refs["sipForm1"].validate((valid) => {
          if (valid) {
            resolve();
          } else {
            // 返回验证失败的表单名称
            reject("sipForm1");
          }
        });
      });
      let sipForm2 = new Promise((resolve, reject) => {
        if (this.isExpandSip2) {
          this.$refs.sipForm2.validate((valid) => {
            console.log(2);
            if (!valid) {
              if (
                this.sipForm2.account.length > 0 ||
                this.sipForm2.password.length > 0 ||
                this.sipForm2.serviceIp.length > 0
              ) {
                this.$Message.error(this.$t("deviceSip.sip2Tip"));
                reject("sipForm2");
              }
            } else {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
      // 异步表单校验
      Promise.all([addForm, netForm, sipForm1, sipForm2])
        .then((res) => {
          // 验证成功 向提交数据
          let nextExe = window.confirm(that.$t("book.coverTip")); // 覆盖提示
          if (nextExe) {
            this.changeDevice();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 循环所有设备
    changeDevice() {
      this.spinShow = true;
      this.batchDeviceNum = 0;

      let allData = this.areaDeviceData;
      this.startIp = this.netForm.ip + "";
      this.setDeepArrData(allData, "groupList", this.netForm.ip);

      if (this.allDeviceNum + this.batchDeviceNum > 10000) {
        this.$Message.error(this.$t("updateNewSip.devMax"));
        this.spinShow = false;
        return;
      }
      this.endIp = this.netForm.ip + "";
      this.$store.commit("projectConfig/SET_AREADEVICEDATA", allData);
      // 添加成功，关闭弹窗
      this.$refs.resultModal.dialogVisible = true;
      this.modalType = true;

      this.$emit("updateTree");
      this.spinShow = false;
      return;
    },
    // 递归查找 tree 数据中的 id 的 名称; 可以传入 字段参数的名称 ，有默认值
    // 递归 遍历深层 数组 要有接收值 才可以
    setDeepArrData(arr, child = "groupList", startIp) {
      let that = this;
      for (let i = 0; i < (arr?.length || 0); i++) {
        let item = arr[i];
        // 判断是区域节点
        // 外围设备列表不参与添加批量设备操作
        if (
          !item.isTopDevice &&
          item.level &&
          item.level === that.currentAreaType
        ) {
          if (!item.groupList) {
            item.groupList = [];
          }

          let currnetDeviceList = [];
          let currentAreaList = item.groupList.filter((item) => item.code);
          let deviceObj = {};

          let allAreaCode = that.getBatchSipAccount(item);

          for (let j = 1; j <= that.currentDeviceNum; j++) {
            this.batchDeviceNum = this.batchDeviceNum + 1;
            // 遍历
            deviceObj = {
              deviceType: this.addForm.deviceType,
              productType: this.addForm.productType,
              funList: this.addForm.funList,
              name: item.codePath + "-" + j, //
              netInfoDTO: {
                mode: this.netForm.mode,
                ip: this.netForm.ip,
                gateway: this.netForm.gateway,
                mask: this.netForm.mask,
                dns1: this.netForm.dns1,
                dns2: this.netForm.dns2,
              },
              sipInfoDTOList: this.putSipForm2(allAreaCode, j),
              $treeNodeId: Math.floor(Math.random() * 1000000000),
            };
            deviceObj = JSON.parse(JSON.stringify(deviceObj));
            currnetDeviceList.push(deviceObj);

            currnetDeviceList = currnetDeviceList.sort((a, b) => {
              return a.name.localeCompare(b.name);
            });
            this.netForm.ip = addDeviceIP(this.netForm.ip, this.netForm.mask); // 迭代ip+1
          }

          // 移除已保存的设备
          item.devList = [];

          // 判断当前节点是否存在子区域
          if (currentAreaList.length > 0) {
            // 有子区域，设备覆盖+保留子区域
            item.groupList = currnetDeviceList.concat(currentAreaList);
          } else {
            // 无子区域,直接覆盖设备
            item.groupList = currnetDeviceList;
          }
          // devList是设备的最终来源
          if (!item.devList) {
            item.devList = [];
          }
          item.devList = currnetDeviceList;
        }

        if (Array.isArray(item[child]) && item[child].length > 0) {
          // 迭代ip
          this.setDeepArrData(item[child], child, this.netForm.ip);
        }
      }
    },
    // 获取批量的sip账号,sip账号由当前区域节点的祖先节点区域编号拼接+设备序号
    getBatchSipAccount(item) {
      // 自己找祖先节点
      let allAreaCode = ""; // 当前区域的所有祖先区域编号拼接
      let allParentNodeArray = getAllParentNode(
        this.areaDeviceData,
        item["$treeNodeId"]
      );
      allParentNodeArray.unshift(item);
      if (allParentNodeArray.length > 0) {
        // 有祖先节点,倒转，按远到近排
        allParentNodeArray = allParentNodeArray.reverse();
        allParentNodeArray = allParentNodeArray.map((item) => {
          return String(item.code).padStart(4, "0"); // 4位，前面自动补0
        });
        allAreaCode = allParentNodeArray.join(""); // 无拼接
      }
      return allAreaCode;
    },

    // 判断sip2是否加入配置中,传入默认参数
    putSipForm2(allAreaCode, index) {
      this.sipForm1.account = allAreaCode + "" + index;
      let sipInfoDTOList = [this.sipForm1];
      if (this.isExpandSip2) {
        this.sipForm2.account = allAreaCode + "" + index;
        sipInfoDTOList.push(this.sipForm2);
      }
      return sipInfoDTOList;
    },
    /** setIp： ip地址进位+1
     *  startIp:递归ip
     *  ip限制:255.254.254.253，每段上限；当各段都达上限，重置0.0.0.0
     *  127.0.0.0:自动+1
     */
    setIp(startIp) {
      let ipArray = startIp.split(".");
      let firstIp = Number(ipArray[3]);
      let secondIp = Number(ipArray[2]);
      let thirdIp = Number(ipArray[1]);
      let fourthIp = Number(ipArray[0]);
      let returnString = 0;

      firstIp = firstIp + 1;
      if (firstIp > 253) {
        firstIp = 0;
        secondIp = secondIp + 1;
        if (secondIp > 254) {
          secondIp = 0;
          thirdIp = thirdIp + 1;

          if (thirdIp > 254) {
            thirdIp = 0;
            fourthIp = fourthIp + 1;

            if (fourthIp === 255) {
              firstIp = 0;
              secondIp = 0;
              thirdIp = 0;
              fourthIp = 0;
            }
          }
        }
      }

      returnString = fourthIp + "." + thirdIp + "." + secondIp + "." + firstIp;
      if (returnString === "127.0.0.0") {
        returnString = "127.0.0.1";
      }
      return returnString;
    },
    // 设置设备型号与功能选择匹配
    setFunList(val) {
      switch (val) {
        case "0":
          this.addForm.funList = [];
          break;
        case "SI701":
          this.addForm.funList = [0, 1, 3];
          break;
        case "SO801":
          this.addForm.funList = [1, 2, 3, 5];
          break;
        case "SO001":
          this.addForm.funList = [1, 2, 3, 5];
          break;
        case "SIA01":
          this.addForm.funList = [0, 1];
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/projectConfig.scss";
.bacth-box-tip {
  display: flex;
  width: 600px;
  word-break: normal;
}
.margin-box {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
